module.exports = __webpack_public_path__ + "static/clientPhoto1-e6d650b5aacc6612d0059d1a9df9d202.jpg";